import React from 'react';
import PropTypes from 'prop-types';
import NumberToMonth from '../../transforms/NumberToMonth';

const TitleYearsBox = ({
  title, from, to, removeItem, editItem,
}) => (
  <li className="title-years__item" key={`${title}${from.year}${to.year}`}>
    <div className="title-years__description">
      {title}
    </div>
    <div className="title-years__dates-values">
      <span className="title-years__from-value">{NumberToMonth(from.month)} {from.year}</span>-
      <span className="title-years__to-value">{NumberToMonth(to.month)} {to.year}</span>
    </div>
    {removeItem && (
      <button
        className="title-years__item-remove"
        onClick={(e) => {
          e.preventDefault();
          removeItem();
        }}
      >
        <i className="fa fa-times" />
      </button>
    )}
    {editItem && (
      <button
        className="title-years__item-edit"
        onClick={(e) => {
          e.preventDefault();
          editItem();
        }}
      >
        <i className="fa fa-pencil" />
      </button>
    )}
  </li>
);

TitleYearsBox.propTypes = {
  title: PropTypes.string.isRequired,
  from: PropTypes.object,
  to: PropTypes.object,
  removeItem: PropTypes.func,
  editItem: PropTypes.func,
};

TitleYearsBox.defaultProps = {
  from: {},
  to: {},
  removeItem: undefined,
  editItem: undefined,
};

export default TitleYearsBox;



// WEBPACK FOOTER //
// ./src/components/TitleYears/Box.js